// Generated with tools/create-component.js
import React, { useEffect } from "react";
import { Container, Icon, Image, Link } from "components";
import { BackgroundColourEnum } from "utils";
import { StandoutCtaQueryFragment } from "codegen";
import "./StandoutCta.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import classNames from "classnames";

interface StandoutCtaProps {
  data: StandoutCtaQueryFragment;
}

export const StandoutCta: React.FC<StandoutCtaProps> = ({ data: { title, cta, backgroundColour } }): JSX.Element => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <Container
      backgroundColour={BackgroundColourEnum[backgroundColour]}
      className={classNames({
        "standout-cta": true,
        "layout--small": true,
      })}
    >
      {title && (
        <h2
          className="title"
          dangerouslySetInnerHTML={{
            __html: title ? title : "",
          }}
        />
      )}

      <div className="standout-cta__items">
        {Object.keys(cta).length > 0 &&
          cta?.map((item, index) => {
            const count = index + 1; // Add one to the index so we don't start with 0.

            return (
              <div key={`${item.id}-${index}`} className="standout-cta__item" data-aos="fade-up">
                <Link to={item.link.url} target={item.link.target}>
                  <div className="standout-cta__content">
                    {item.image && <div className="standout-cta__image">{<Image src={item.image} className="" />}</div>}
                    <span className="count">0{count}</span>
                    <Icon name="ArrowLink" color="currentColor" size={1} />

                    {item.link.title && (
                      <h3
                        className="typography--h3"
                        dangerouslySetInnerHTML={{
                          __html: item.link.title ? item.link.title : "",
                        }}
                      />
                    )}
                  </div>
                </Link>
              </div>
            );
          })}
      </div>
    </Container>
  );
};
